module.exports = __webpack_public_path__ + "static/media/section.7c8fdd61.svg";